import { TasksContextProps } from 'src/providers/Tasks/TaskNotifications.types';
import { useTasksContext } from 'src/providers/Tasks/TaskNotificationsContext';

export const useTaskNotifications = (): TasksContextProps => useTasksContext();
